








































































import { UiConfirm, UiIconButton, UiRadioGroup, UiSelect, UiTextbox } from '../keen-ui';

import { Pagination } from '../../models';

enum DownloadOptionEnum {
  CURRENT = 'current',
  CUSTOM = 'custom'
}

export default {
  name: 'pagination-bar',
  components: {
    UiSelect,
    UiIconButton,
    UiConfirm,
    UiRadioGroup,
    UiTextbox
  },
  computed: {
    pageInfoText: function (): string {
      const firstItemPage = Math.min((((this.pagination.page - 1) * this.pagination.itemsPerPage) + 1), this.pagination.totalItems);
      let pageInfoText = firstItemPage.toLocaleString(this.$epb.locale);
      const lastItemPage = Math.min((this.pagination.page * this.pagination.itemsPerPage), this.pagination.totalItems);
      if (lastItemPage !== firstItemPage) {
        pageInfoText += ` - ${lastItemPage.toLocaleString(this.$epb.locale)}`;
      }
      pageInfoText += ` ${this.$epb.messages.crud.pagination.ofTotal} ${this.pagination.totalItems.toLocaleString(this.$epb.locale)}`;
      return pageInfoText;
    },
    lastPage: function (): number {
      return Math.ceil(this.pagination.totalItems / this.pagination.itemsPerPage);
    },
    downloadOptions: function (): any[] {
      return [
        {
          label: this.$epb.messages.crud.pagination.download.currentPage,
          value: DownloadOptionEnum.CURRENT
        }, {
          label: this.$epb.messages.crud.pagination.download.custom,
          value: DownloadOptionEnum.CUSTOM
        }
      ];
    }
  },
  data: function () {
    return {
      DownloadOptionEnum,
      itemsPerPageString: this.pagination.itemsPerPage.toString(),
      iconButtonConfig: {
        type: 'secondary'
      },
      download: {
        selectedOption: DownloadOptionEnum.CURRENT,
        itemsPerPageString: '',
        start: 1
      }
    };
  },
  methods: {
    updatePage: function (page: number): void {
      const pageIsValid = ((page >= 1) && (page <= this.lastPage));
      if ((page !== this.pagination.page) && pageIsValid) {
        this.$emit('paginationChange', {
          ...this.pagination,
          page: page
        });
      }
    },
    updateItemsPerPage: function (itemsPerPage: number): void {
      if (itemsPerPage !== this.pagination.itemsPerPage) {
        this.$emit('paginationChange', {
          ...this.pagination,
          page: 1,
          itemsPerPage: itemsPerPage
        });
      }
    },
    onDownload: function (): void {
      this.download.selectedOption = DownloadOptionEnum.CURRENT;
      if (!!this.downloadItemsPerPageOptions.length) {
        if (!this.download.itemsPerPageString) {
          this.download.itemsPerPageString = this.downloadItemsPerPageOptions[0].toString();
        }
        this.validateDownloadStart();
        this.$refs.downloadDialog.open();
      } else {
        this.onConfirmDownload();
      }
    },
    validateDownloadStart: function (): void {
      if (this.download.start > this.pagination.totalItems) {
        this.download.start = this.pagination.totalItems;
      }
      if (!this.download.start || (this.download.start < 1)) {
        this.download.start = 1;
      }
    },
    onConfirmDownload: function (): void {
      const pagination: Pagination = {
        ...this.pagination
      };
      if (this.download.selectedOption !== DownloadOptionEnum.CURRENT) {
        pagination.itemsPerPage = Number(this.download.itemsPerPageString);
        pagination.page = (Math.floor((Number(this.download.start) - 1) / pagination.itemsPerPage) + 1);
      }
      this.$emit('download', pagination);
    }
  },
  props: {
    pagination: Object,
    itemsPerPageOptions: {
      type: Array,
      default: function (): number[] {
        return [this.pagination.itemsPerPage];
      }
    },
    lastPageDisabled: Boolean,
    downloadEnabled: Boolean,
    downloadItemsPerPageOptions: {
      type: Array,
      default: () => []
    },
    downloadDialogTitle: String
  },
  watch: {
    pagination: function (pagination: Pagination): void {
      this.itemsPerPageString = pagination.itemsPerPage.toString();
    },
    itemsPerPageString: function (itemsPerPageString: string): void {
      this.updateItemsPerPage(Number(itemsPerPageString));
    }
  }
};

